import React from "react";
import { contentStart } from "../../algorithms/styleDirection";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
const FilesList = ({
  Data,
  backgroundColor,
  height,
  containerStyle,
  contentStyle,
  setFiles,
  setFilesInFormik,
  setFilesTouched,
  setError,
  error,
  propInFormik,
}) => {
  // const {} = props;

  // const [DataSource, setData] = useState([...Data]);
  return (
    <>
      <div className={`d-flex scroll_design ${containerStyle}`}>
        <div
          className={` ${contentStyle}`}
          style={{
            backgroundColor: backgroundColor ?? "#F2F2F2",
            overflowY: "auto",
            height: height ?? 120,
          }}
        >
          {Data.length ? (
            Data.map((item, index) => {
              return (
                <div
                  className=" d-flex justify-content-around my-2 container text-center flex-wrap py-1"
                  key={index}
                >
                  <div className="col-1 d-none d-sm-block">
                    {" "}
                    <Icon
                      color={"#414952"}
                      name={"paperclip"}
                      size={20}
                      iconPrefix={"fas"}
                      onclick={() => {}}
                    ></Icon>
                  </div>
                  <div
                    className={`col-lg-5  col-sm-6 col-8 ${contentStart(
                      "text"
                    )}`}
                    style={{ lineHeight: 0.4 }}
                  >
                    <h6> {item.fileName} </h6>
                    <div className="text-muted" style={{ fontSize: 12 }}>
                      {" "}
                      {item.fileType}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-3 d-none d-md-block">
                    {" "}
                    <hr style={{ height: 3, color: "#656565" }} />{" "}
                  </div>
                  <div className="col-1">
                    {" "}
                    <Icon
                      color={"#414952"}
                      name={"trash-alt"}
                      size={22}
                      iconPrefix={"far"}
                      onclick={() => {
                        const allFiles = Data.filter((i) => i.id !== item.id);
                        setFiles(allFiles);
                        if (allFiles.length)
                          setFilesInFormik(propInFormik, allFiles);
                        else {
                          setFilesTouched(propInFormik, true);
                          setFilesInFormik(propInFormik, undefined);
                          if (setError) setError(true);
                        }
                      }}
                    ></Icon>
                  </div>
                </div>
              );
            })
          ) : (
            <>
              <div className="text-center"> {Lang.noFiles} </div>
              {error === true ? (
                <div className="text-center text-danger"> {Lang.require} </div>
              ) : null}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default FilesList;
